/**
 * LotSmith — Demo-mode banner.
 *
 * Renders only when the user finished onboarding with "Skip — explore demo".
 * Reads state from localStorage so it persists across reloads. A single
 * dismiss click clears the flag.
 */
import { useEffect, useState } from "react";

const KEY = "lsm_demo_mode";
const DISMISSED = "lsm_demo_dismissed";

export function DemoBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const demo = localStorage.getItem(KEY) === "1";
      const dismissed = localStorage.getItem(DISMISSED) === "1";
      setShow(demo && !dismissed);
    } catch {
      /* localStorage unavailable */
    }
  }, []);

  if (!show) return null;

  return (
    <div className="demo-banner" role="status">
      <span className="demo-banner__dot" aria-hidden="true" />
      <span className="demo-banner__msg">
        Exploring with demo data. Install the EA to see your real trades.
      </span>
      <button
        type="button"
        className="demo-banner__close"
        onClick={() => {
          try { localStorage.setItem(DISMISSED, "1"); } catch { /* ignore */ }
          setShow(false);
        }}
        aria-label="Dismiss demo banner"
      >
        ×
      </button>
    </div>
  );
}
